import React from 'react'
import { CopyToClipboardButton } from 'shared/components/copy-to-clipboard-button'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { StatusCell } from 'shared/components/table/cells/status-cell'
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import {
  UserDomainWithWebsiteInterface,
  WebsiteId,
  WebsiteInterface,
} from '../types/website-interface'
import { getUrlWebsiteEdit } from '../utils/get-url'

export const websiteTableColumns = ({
  t,
  userDomainsWithWebsite,
  onNameClick,
}: {
  t: TLocoType
  userDomainsWithWebsite?: UserDomainWithWebsiteInterface[]
  onNameClick: (websiteId: WebsiteId) => void
}): ColumnDefinitionInterface<WebsiteInterface>[] => [
  // {
  //   key: 'previewImage',
  //   header: t('global.preview_image_label'),
  //   widthPercent: 20,
  //   onRender: () => <div className={'w-[180px] h-[105px] bg-skeleton-primary rounded-sm'} />,
  // },
  {
    key: 'name',
    header: t('global.name'),
    widthPercent: 45,
    onRender: website => (
      <div className="truncate">
        {website.templateId && website.homePage ? (
          <LinkWithoutPrefetch
            className="primary-link w-full cursor-pointer"
            href={getUrlWebsiteEdit(website.homePage.pageContentId) ?? ''}
          >
            {website.name}
          </LinkWithoutPrefetch>
        ) : (
          <>
            <span
              className="primary-link w-full cursor-pointer"
              onClick={() => onNameClick(website.id)}
            >
              {website.name}
            </span>
          </>
        )}
      </div>
    ),
  },
  {
    key: 'path',
    header: t('dashboard.website.home_page_title'),
    onRender: website => {
      if (!userDomainsWithWebsite)
        return (
          <div className={'bg-skeleton-primary animate-pulse rounded-md px-10 text-transparent'}>
            .
          </div>
        )
      const domainName = userDomainsWithWebsite?.find(el => el.id === website.domainId)?.name

      const homePageUrl =
        domainName &&
        `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${domainName}/${website.homePagePath}`

      return homePageUrl ? (
        <div className="flex w-full gap-3">
          <div className="truncate">{homePageUrl}</div>
          <CopyToClipboardButton text={homePageUrl} />
        </div>
      ) : (
        <></>
      )
    },
    widthPercent: 45,
  },
  {
    key: 'active',
    header: t('global.status'),
    widthPercent: 10,
    onRender: ({ active }) => <StatusCell isActive={active} />,
  },
]
